import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import InfoRowData from './InfoRowData';

export default function ReportAdditionalFields({ additionalFields }) {
  return (
    <div>
      <ReportSectionTitle title={localize.additional_data} />
      <div className="report_section_without_top_border">
        {additionalFields?.map((row) => (
          <div key={`${row.guid}0`}>
            <InfoRowData
              registerId={row.guid}
              leftField={{
                Name: `${row.name}:`,
                Value: row.value,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
